var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 535,
    height: 959,
    viewBox: "0 0 535 959",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M533.218 250.835L533.105 956.939H2.27169L2.15883 256.418C26.0538 -79.889 502.337 -84.8686 533.218 250.835ZM514.52 940.098L516.237 940.49L516.237 938.728L516.379 256.341V256.299L516.376 256.258C512.356 187.661 483.36 121.679 429.486 78.0414L429.142 77.7628L428.7 77.7317C368.811 73.5037 304.566 93.5878 254.128 130.457C203.684 167.331 166.926 221.091 162.259 284.286L162.255 284.338V284.39L162.326 853.298L162.326 853.762L162.602 854.134L167.38 860.579L167.69 860.996L168.196 861.112L514.52 940.098Z",
    stroke: "rgba(255, 255, 255, 0.1)",
    strokeWidth: 1.80984
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar);
export default __webpack_public_path__ + "static/media/sidebar.ac4d68268990f1c95b928fbf7a13fce4.svg";
export { ForwardRef as ReactComponent };